import { useState, useEffect } from 'react'
import { Menu, Tag } from 'antd'
import Cookies from 'js-cookie'
import { useTranslation } from 'react-i18next'
import { useHistory, useLocation, Link } from 'react-router-dom'
import { useSelector } from 'react-redux'
import navTree from '../../configs/NavConfig/Admin'
import { ADMIN_AUTH_PREFIX_PATH } from '../../configs/AppConfig'
import { initializePusher } from '../../configs/pusher'
import { openNotification } from '../../utils/utils'

import { ReactComponent as Logout } from '../shared-components/svgs/sider/logout.svg'

const { SubMenu } = Menu

export default function MenuContent({ setNavOpen }) {
  const { t } = useTranslation()
  const history = useHistory()
  const location = useLocation()

  const { profile, hasFullPermissions, permissions } = useSelector(
    (state) => state.myProfile
  )

  const [autherizedLinks, setAutherizedLinks] = useState([])

  useEffect(() => {
    setAutherizedLinks([])
    if (profile) {
      navTree.forEach((link) => {
        if (link.submenu && link.submenu.length > 0) {
          let submenu = []

          link.submenu.forEach((subLink) => {
            const subRoles = Array.isArray(subLink.role) ? subLink.role : (subLink.role ? [subLink.role] : [])
            const hasPermission = subRoles.length > 0 ? permissions.some((permission) =>
              subRoles.includes(permission.name)
            ) : true

            if (hasPermission) submenu.push(subLink)
          })

          if (submenu.length > 0) {
            // Further verify the main link has access if it has specific roles defined,
            // or if it doesn't, it just relies on the submenus.
            let hasMainPermission = true
            if (link.role) {
                 const roles = Array.isArray(link.role) ? link.role : [link.role]
                 hasMainPermission = permissions.some((permission) => roles.includes(permission.name))
            }
            if (hasMainPermission) {
              const menu = { ...link, submenu }
              setAutherizedLinks((autherizedLinks) => [...autherizedLinks, menu])
            }
          }
        } else if (link.role) {
          const roles = Array.isArray(link.role) ? link.role : [link.role]
          const hasPermission = permissions.some((permission) =>
            roles.includes(permission.name)
          )

          if (hasPermission)
            setAutherizedLinks((autherizedLinks) => [...autherizedLinks, link])
        }
      })
    }
  }, [profile, hasFullPermissions, permissions])

  useEffect(() => {
    const pusher = initializePusher(true)
    const channelName = 'admin.unreaded_chat_messages'
    const existingChannel = pusher.channel(channelName)
    const messageSound = new Audio('/sounds/mixkit-correct-answer-tone.wav')

    if (!existingChannel) {
      const channel = pusher.subscribe(channelName)
      console.log('LOGGING 3', channel)
      channel.bind('unreaded_message_evt', function (data) {
        console.log(data)
        messageSound.play().catch((error) => {
          console.error('Error playing sound:', error)
        })

        openNotification('info', t('New Unread Message'))
      })

      return () => {
        pusher.unsubscribe(channelName)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Menu mode='inline'>
      {/* NAVLINKS */}
      {autherizedLinks &&
        autherizedLinks.map((menu) =>
          menu.submenu.length > 0 ? (
            <SubMenu
              key={menu.key}
              icon={
                location.pathname.split('/')[3] === menu.path.split('/')[3]
                  ? menu.iconActive
                  : menu.icon
              }
              title={t(menu.title)}
            >
              {menu.submenu.map((subMenu) => (
                <Menu.Item
                  key={subMenu.key}
                  className={`${location.pathname.split('/')[4] ===
                    subMenu.path.split('/')[4] &&
                    location.pathname.split('/')[3] ===
                    subMenu.path.split('/')[3]
                    ? 'active'
                    : ''
                    }`}
                  onClick={() => setNavOpen(false)}
                >
                  <div className='d-flex align-items-center gap-1'>
                    {t(subMenu.title)}
                    <Link to={subMenu.path} />{' '}
                    {/* {subMenu.key === 'Messages' && (
                      <Tag
                        color='#f50'
                        className='rounded-circle fs-12 text-center p-0 d-flex align-items-center justify-content-center'
                        style={{ width: '24px', height: '24px' }}
                      >
                        10
                      </Tag>
                    )} */}
                  </div>
                </Menu.Item>
              ))}
            </SubMenu>
          ) : (
            <Menu.Item
              key={menu.key}
              icon={
                location.pathname.split('/')[3] === menu.path.split('/')[3]
                  ? menu.iconActive
                  : menu.icon
              }
              className={`${location.pathname.split('/')[3] === menu.path.split('/')[3]
                ? 'active'
                : ''
                }`}
              onClick={() => setNavOpen(false)}
            >
              {t(menu.title)}
              <Link to={menu.path} />
            </Menu.Item>
          )
        )}

      {/* LOGOUT */}
      <Menu.Item
        key='logout'
        icon={<Logout />}
        className='logout'
        onClick={() => {
          Cookies.remove('SMARTCAF_JWT_TOKEN', { path: '/' })
          history.push(`${ADMIN_AUTH_PREFIX_PATH}`)
          window.location.reload()
        }}
      >
        {t('sidenav.logout')}
      </Menu.Item>
    </Menu>
  )
}
